import { useNavigate } from "react-router";
import styles from "./main.module.css";

export default function Main() {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        
        <div className={styles.card}>
          <h1 className={styles.title}>
            Добро пожаловать в Sivil Lab
          </h1>

          <p className={styles.text}>
            Этот сайт предназначен для удобной работы с заказами компании.
            В данный момент регистрация доступна по почте
            <a href="mailto:potcha@gmail.com" className={styles.link}>
              {" "}potcha@gmail.com
            </a>.
          </p>

          <p className={styles.subtext}>
            Если у вас уже есть аккаунт, вы можете войти.
          </p>

          <button
            className={styles.button}
            onClick={() => navigate("/auth/login")}
          >
            Перейти ко входу
          </button>
        </div>

        <div className={styles.imageWrapper}>
          <img
            src="https://static.tildacdn.com/tild6233-3233-4339-b535-643562373765/2022-06-27_11-42-45.png"
            alt="Sivil Lab"
            className={styles.image}
          />
        </div>

      </div>
    </div>
  );
}